import Vue from 'vue'

export default function giveOutToStudent({ out_id, lesson_id }) {
    const proxy = process.env.VUE_APP_PROXY
    const api_uri = process.env.VUE_APP_API_URI

    let url = proxy + api_uri + "/bookouts/" + out_id
    return Vue.http
        .post(url, { lesson_id }, {
            headers: {
                'Content-Type': 'application/json'
            }
        })
        .then(response => response.json()).catch((e) => { throw e })
}